import { computed } from "vue";
import { createRouter, createWebHistory } from "@ionic/vue-router";
import {
  NavigationGuardNext,
  RouteLocationNormalized,
  RouteRecordRaw,
} from "vue-router";
import { Preferences } from "@capacitor/preferences";
import TabsPage from "../views/TabsPage.vue";
import LoginPage from "../views/Auth/AuthLogin.vue";
import SignupPage from "../views/Auth/Signup.vue";
import { useUserStore } from "@/store/modules/user";
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/tabs/home",
  },
  {
    path: "/tabs/",
    component: TabsPage,
    children: [
      {
        path: "",
        redirect: "home",
      },
      {
        path: "home",
        name: "Home",
        component: () => import("@/views/HomePage.vue"),
        meta: { middleware: "Auth" },
      },
      {
        path: "explore",
        name: "Explore",
        component: () => import("@/views/ExplorePage.vue"),
        meta: { middleware: "Auth" },
      },
      {
        path: "scan",
        name: "Scan",
        component: () => import("@/views/TestScan/ScannerPage.vue"),
        meta: { middleware: "Auth" },
      },
      {
        path: "products",
        name: "Products",
        component: () => import("@/views/Product/ProductList.vue"),
        meta: { middleware: "Auth" },
      },
      {
        path: "brands",
        name: "Brands",
        component: () => import("@/views/Brand/BrandList.vue"),
        meta: { middleware: "Auth" },
      },
      {
        path: "events",
        name: "Events",
        component: () => import("@/views/Event/ListPage.vue"),
        meta: { middleware: "Auth" },
      },
      {
        path: "featured-content",
        name: "FeaturedContent",
        component: () => import("@/views/FeaturedContent.vue"),
        meta: { middleware: "Auth" },
      },
      {
        path: "featured-content/:id",
        name: "FeaturedContentDetail",
        component: () => import("@/views/FeaturedContentDetail.vue"),
        meta: { middleware: "Auth" },
      },
      {
        path: "community-activities",
        name: "CommunityActivities",
        component: () => import("@/views/CommunityActivities.vue"),
        meta: { middleware: "Auth" },
      },
      {
        path: "community-content/:id",
        name: "CommunityContentDetail",
        component: () => import("@/views/CommunityContentDetail.vue"),
        meta: { middleware: "Auth" },
      },
      {
        path: "routines",
        name: "Routines And Beauty Scripts",
        component: () => import("@/views/RoutinesPage.vue"),
        meta: { middleware: "Auth" },
      },
      {
        path: "routines/:id",
        name: "Routine Detail",
        component: () => import("@/views/Routine/RoutineDetailPage.vue"),
        meta: { middleware: "Auth" },
      },
      // {
      //   path: '/routines',
      //   name: 'Routines',
      //   component: () => import('@/views/RoutinesPage.vue'),
      //   meta: { middleware: 'Auth' },
      // },
      // {
      //   path: '/routines/:id',
      //   name: 'RoutineDetail',
      //   component: () => import('@/views/RoutinesPage.vue'),
      //   meta: { middleware: 'Auth' },
      // },
      {
        path: "/profile/:id",
        name: "Profile",
        component: () => import("@/views/Profile/ProfilePage.vue"),
        meta: { middleware: "Auth" },
      },
      {
        path: "/product-detail/:reviewId/review/",
        name: "ProductReviewDetails",
        component: () => import("@/views/Product/ProductDetail.vue"),
        meta: { middleware: "Auth" },
      },
      {
        path: "/product-detail/:id",
        name: "ProductDetails",
        component: () => import("@/views/Product/ProductDetail.vue"),
        meta: { middleware: "Auth" },
      },
      {
        path: "/influencerList",
        name: "InfluencerList",
        component: () => import("@/views/Influencer/InfluencerList.vue"),
        meta: { middleware: "Auth" },
      },
    ],
  },

  {
    path: "/products/:search",
    name: "Product-Search",
    component: () => import("@/views/Product/ProductSearch.vue"),
    meta: { middleware: "Auth" },
  },

  {
    path: "/productnotfound",
    name: "ProductNotFound",
    component: () => import("@/views/Product/ProductNotFound.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/productnotfoundsubmit",
    name: "ProductNotFoundSubmit",
    component: () => import("@/views/Product/ProductNotFoundSubmit.vue"),
    meta: { middleware: "Auth" },
  },

  {
    path: "/product-detail/:id/add-review",
    name: "ProductAddReview",
    component: () => import("@/views/Review/AddReview.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/product-suggestion",
    name: "ProductSuggestion",
    component: () => import("@/views/Product/ProductSuggestion.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/brands/:search",
    name: "Brands-Search",
    component: () => import("@/views/Brand/BrandSearch.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/brand-detail/:id",
    name: "BrandDetails",
    component: () => import("@/views/Brand/BrandDetail.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/brand-detail/:id/add-review",
    name: "BrandAddReview",
    component: () => import("@/views/Review/AddReview.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/brand/add-suggest",
    name: "AddSuggestBrand",
    component: () => import("@/views/Brand/AddSuggestBrand.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/add-review/:type/:id",
    name: "AddReview",
    component: () => import("@/views/Product/ReviewPage.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/routines",
    name: "Routines",
    component: () =>
      import("@/views/Profile/Tabs/Routine/RoutineSearchPage.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/my-routines",
    name: "MyRoutines",
    component: () => import("@/views/Profile/Tabs/Routine/MyRoutinesPage.vue"),
    meta: { middleware: "Auth" },
  },

  {
    path: "/profile/edit",
    name: "Profile-Edit",
    component: () => import("@/views/Profile/ProfileEdit.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/profile/create/addphoto",
    name: "ProfileAddphotoComponent",
    component: () =>
      import("@/views/Auth/CreateProfile/ProfileAddphotoComponent.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/profile/create/final",
    name: "ProfileAddFinal",
    component: () => import("@/views/Auth/CreateProfile/ProfileAddFinal.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/profile/create/header",
    name: "ProfileAddHeader",
    component: () => import("@/views/Auth/CreateProfile/ProfileAddHeader.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/profile/create/info",
    name: "ProfileAddInfo",
    component: () => import("@/views/Auth/CreateProfile/ProfileAddInfo.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/profile/create/secquestion",
    name: "ProfileAddSecQuestion",
    component: () =>
      import("@/views/Auth/CreateProfile/ProfileAddSecQuestion.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/events/:search",
    name: "Event-Search",
    component: () => import("@/views/Event/EventSearch.vue"),
    meta: { middleware: "Auth" },
  },

  {
    path: "/event-detail/:id",
    name: "EventDetail",
    component: () => import("@/views/Event/DetailPage.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/event/add",
    name: "AddEvent",
    component: () => import("@/views/Event/AddEvent.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/sku",
    component: () => import("@/views/SkuPage.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/tabs/shop",
    component: () => import("@/views/ShopPage.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/login",
    name: "Login",
    component: LoginPage,
  },
  {
    path: "/signup",
    name: "Signup",
    component: SignupPage,
  },
  {
    path: "/forgot-password/email",
    name: "ForgotPasswordEmail",
    component: () => import("@/views/Auth/ForgotPasswordEmail.vue"),
  },
  {
    path: "/forgot-password/code",
    name: "ForgotPasswordCode",
    component: () => import("@/views/Auth/ForgotPasswordCode.vue"),
  },
  {
    path: "/create-new-password",
    name: "CreateNewPassword",
    component: () => import("@/views/Auth/CreateNewPassword.vue"),
    meta: { middleware: "reset-password" },
  },
  {
    path: "/reset-password/success",
    name: "PasswordResetSuccess",
    component: () => import("@/views/Auth/PasswordResetSuccess.vue"),
  },

  {
    path: "/following-request",
    name: "Following Request",
    component: () => import("@/views/Follow/UserFollowingRequest.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/setting-privacy",
    name: "SettingAndPrivacy",
    component: () => import("@/views/Setting/SettingAndPrivacy.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/account-info",
    name: "AccountInformation",
    component: () => import("@/views/Setting/AccountInformation.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/change-password",
    name: "ChangePassword",
    component: () => import("@/views/Setting/ChangePassword.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/blocked-users",
    name: "BlockedUsers",
    component: () => import("@/views/Setting/BlockedUsers.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/notification",
    name: "NotificationPage",
    component: () => import("@/views/NotificationPage.vue"),
    meta: { middleware: "Auth" },
  },

  {
    path: "/myshelf/add",
    name: "Add-Shelf",
    component: () => import("@/views/Profile/Tabs/MyShelf/AddShelf.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/myshelf/edit",
    name: "Edit-Shelf",
    component: () => import("@/views/Profile/Tabs/MyShelf/EditShelf.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/routine/:id",
    name: "Routine-Detail",
    component: () => import("@/views/Profile/Tabs/Routine/RoutineDetail.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/routine/:id/edit",
    name: "Routine-Edit",
    component: () => import("@/views/Profile/Tabs/Routine/EditRoutine.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/routine/add",
    name: "Add-Routine",
    component: () => import("@/views/Profile/Tabs/Routine/AddRoutine.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/squad/add",
    name: "Add-Squad",
    component: () => import("@/views/Profile/Tabs/GlamSquad/AddSquad.vue"),
    meta: { middleware: "Auth" },
  },
  {
    path: "/squad/edit",
    name: "Edit-Squad",
    component: () => import("@/views/Profile/Tabs/GlamSquad/EditSquad.vue"),
    meta: { middleware: "Auth" },
  },
];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

const guard = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
  token?: any,
  code?: boolean | null
) => {
  if (to.meta && to.meta?.middleware === "Auth") {
    if (token) {
      const userStore = useUserStore();
      const user = computed(() => userStore?.user);
      const editedProfile = computed(() => userStore?.editedProfile);
      if (to.name === "Home") {
        if (
          editedProfile.value ||
          user.value?.avatar ||
          (user.value?.profile?.bgBanner &&
            user.value?.firstName &&
            user.value?.lastName &&
            (user.value?.profile.eyecolor ||
              user.value?.profile.hairtype ||
              user.value?.profile.skintype))
        ) {
          return next();
        } else {
          return next({ name: "ProfileAddphotoComponent" });
        }
      }
      return next();
    }
    return next({ name: "Login" });
  } else if (to.meta && to.meta?.middleware === "reset-password") {
    if (code) {
      return next();
    }
    return next({ name: "ForgotPasswordEmail" });
  } else {
    if (token) {
      return next({ name: "Home" });
    }
    return next();
  }
};

router.beforeEach(async (to, from, next) => {
  // document.title = `${to.meta.title} - ${process.env.VUE_APP_NAME}`;
  const userStore = useUserStore();
  const authToken = computed(() => userStore?.token);
  const code = computed(() => userStore?.isCode);
  if (!authToken.value) {
    const tempToken = await Preferences.get({ key: "accessToken" });
    if (tempToken.value) {
      const result = await userStore.checkAuth(tempToken.value);
      if (result) {
        return guard(to, from, next, tempToken.value, code.value);
      } else {
        return guard(to, from, next, null, code.value);
      }
    } else {
      return guard(to, from, next, null, code.value);
    }
  } else {
    return guard(to, from, next, authToken.value, code.value);
  }
});

export default router;
